import React, { useState, useContext } from 'react';
import OfficeHourRow from './OfficeHourRow'
import OfficeHourable from '../../concerns/OfficeHourable'
import { OfficeHourSubscriptionsContext } from '../../contexts/OfficeHourSubscriptions'
import { SubscriptionsContext } from '../../contexts/Subscriptions'
import { LineItemsExtensionContext } from '../../contexts/LineItemsExtension'

export default function OfficeHoursTable(props) {
  const officeHourSubscriptions = useContext(OfficeHourSubscriptionsContext);
  const subscriptions = useContext(SubscriptionsContext);
  const lineItemsExtension = useContext(LineItemsExtensionContext);

  const officeHoursUnassigned = OfficeHourable.unassigned(officeHourSubscriptions, subscriptions, lineItemsExtension);

  return (
    <div>
      <br/><br/>
      <div><h2>Office Hours</h2></div>
        <table className="responsive subscriptions"><tbody>
          {
            officeHoursUnassigned.map((officeHour, index) => {
              return <OfficeHourRow key={officeHour.id} id={officeHour.id} />
            })
          }
        </tbody></table>
      </div>
    )
}
